<template>
  <el-dialog
    class="updateGroupChat"
    :title="title"
    :visible.sync="visible"
    width="500px"
  >
    <!-- 修改 -->
    <ConfigForms
      v-if="isEdit"
      ref="form"
      labelWidth="110px"
      :formItems="formItems"
      :data="formData"
      inline
    />
    <!-- 新增 -->
    <ConfigForms
      v-else
      ref="form"
      labelWidth="110px"
      :formItems="addformItems"
      :data="addformData"
      inline
    />
    <span slot="footer" class="dialog-footer">
      <el-button @click="close" size="small">取 消</el-button>
      <el-button type="primary" @click="sure" size="small">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ConfigForms from "@/components/ConfigForms";
import API from "@/api";
const formItems = [
  { label: "原因", key: "reason", type: "textarea" },
  {
    label: "状态",
    key: "status",
    type: "select",
    required: true,
    options: [
      { label: "审核通过", value: 1 },
      { label: "拒绝", value: 2 },
      { label: "下架", value: 3 },
      { label: "待审核", value: 0 },
    ],
  },
];
const addformItems = [
  {
    label: "标题",
    key: "title",
    type: "text",
    required: true,
  },
  {
    label: "用户id",
    key: "uid",
    type: "number",
    required: true,
  },
  {
    label: "类型",
    key: "type",
    type: "select",
    required: true,
    options: [
      { label: "ai图片换脸", value: 1 },
      { label: "ai视频换脸", value: 2 },
      { label: "ai脱衣", value: 3 },
      { label: "ai图生视频", value: 4 },
      { label: "ai绘画", value: 5 },
    ],
  },
];
export default {
  name: "UpdateAiPlaza",
  emit: ["close"],
  components: { ConfigForms },
  data() {
    return {
      visible: false,
      formItems,
      addformItems,
      formData: null,
      addformData: {
        groupId: undefined,
        uid: undefined,
        content: "",
        image: "",
      },
    };
  },
  watch: {},
  computed: {
    isEdit() {
      return !!this.formData;
    },
    title() {
      return this.isEdit ? "修改" : "新增";
    },
  },
  created() {},
  methods: {
    close() {
      this.visible = false;
    },
    open(row) {
      this.formData = null;
      this.addformData = {
        groupId: undefined,
        uid: undefined,
        content: "",
        image: "",
      };
      if (row) {
        this.formData = row;
      }
      this.visible = true;
    },
    async sure() {
      try {
        const form = await this.$refs.form.validate();
        const data = { ...form };
        // 修改
        if (this.isEdit) {
          this.update(data);
        } else {
          // 新增
          this.addHandle(data);
        }
      } catch (error) {
        console.error("sure error:", error);
      }
    },
    async addHandle(data) {
      try {
        const res = await API.createAiplaza(data);
        if (res.code === 200) {
          this.$message({
            message: "新增成功",
            type: "success",
          });
          this.close();
          this.$emit("success");
        } else {
          this.$message.error("新增失败！");
        }
      } catch (err) {
        console.log("add: ", err);
      }
    },
    async update(data) {
      try {
        const res = await API.updateAiplaza(data);
        if (res.code === 200) {
          this.$message({
            message: "修改成功",
            type: "success",
          });
          this.close();
          this.$emit("success");
        } else {
          this.$message.error("修改失败！");
        }
      } catch (err) {
        console.log("update: ", err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.updateGroupChat {
  /deep/ .el-date-editor.el-input {
    width: 200px;
  }
  /deep/ .el-input-number__decrease {
    display: none;
  }
  /deep/ .el-input-number__increase {
    display: none;
  }
  /deep/ .el-input__inner {
    padding-left: 10px;
    padding-right: 10px;
    text-align: left;
  }
}
</style>
